
import React, { useState } from "react";
import "./pagestyles/Checkout.css";


// SVG Components for logos
// const AppleLogo = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="currentColor"
//     aria-hidden="true"
//   >
//     <path d="M16.365 1.43c-.44.53-1.044 1.01-1.756 1.01-.717 0-1.273-.48-1.758-1.01C12.19.952 11.37 0 10.15 0c-1.39 0-2.6.91-3.1 2.17-1.435 3.4.364 8.48 3.67 11.26 1.066.82 2.24 1.64 3.82 1.64 1.46 0 2.13-.52 3.4-1.59-.086-.058-2.87-1.68-2.86-5.04 0-2.4 2.07-3.6 2.18-3.7-.12-.16-1.88-1.57-3.32-.01z"/>
//   </svg>
// );

// Apple logo (black)
const AppleLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="#000"
  >
    <path d="M16.365 1.43c-.44.53-1.044 1.01-1.756 1.01-.717 0-1.273-.48-1.758-1.01C12.19.952 11.37 0 10.15 0c-1.39 0-2.6.91-3.1 2.17-1.435 3.4.364 8.48 3.67 11.26 1.066.82 2.24 1.64 3.82 1.64 1.46 0 2.13-.52 3.4-1.59-.086-.058-2.87-1.68-2.86-5.04 0-2.4 2.07-3.6 2.18-3.7-.12-.16-1.88-1.57-3.32-.01z"/>
  </svg>
);


// Google logo (multicolor G)
const GoogleLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 48 48"
  >
    <path fill="#4285F4" d="M24 9.5c3.54 0 6.38 1.5 7.85 2.77l5.76-5.76C32.62 3.79 28.62 2 24 2 14.92 2 7.25 7.92 4.78 16.23l6.7 5.22C12.04 15.33 17.5 9.5 24 9.5z"/>
    <path fill="#34A853" d="M46.5 24c0-1.67-.15-2.91-.48-4.2H24v7.95h12.86c-.24 1.63-1.56 4.45-4.35 6.21l6.67 5.18C44.8 34.2 46.5 29.74 46.5 24z"/>
    <path fill="#FBBC05" d="M11.5 28.25c-.5-1.5-.5-2.83 0-4.33l-6.7-5.22C3.1 21.93 2 23.85 2 26c0 2.15 1.1 4.07 2.8 5.3l6.7-5.05z"/>
    <path fill="#EA4335" d="M24 46c6.38 0 11.7-2.1 15.6-5.7l-7.62-5.94c-2.1 1.45-4.8 2.33-7.98 2.33-6.54 0-12.1-4.4-14.1-10.3l-6.7 5.22C8.9 41.9 15.7 46 24 46z"/>
  </svg>
);



// const GoogleLogo = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="20"
//     height="20"
//     viewBox="0 0 48 48"
//     aria-hidden="true"
//   >
//     <path fill="#4285F4" d="M24 9.5c3.54 0 6.38 1.5 7.85 2.77l5.76-5.76C32.62 3.79 28.62 2 24 2 14.92 2 7.25 7.92 4.78 16.23l6.7 5.22C12.04 15.33 17.5 9.5 24 9.5z"/>
//     <path fill="#34A853" d="M46.5 24c0-1.67-.15-2.91-.48-4.2H24v7.95h12.86c-.24 1.63-1.56 4.45-4.35 6.21l6.67 5.18C44.8 34.2 46.5 29.74 46.5 24z"/>
//     <path fill="#FBBC05" d="M11.5 28.25c-.5-1.5-.5-2.83 0-4.33l-6.7-5.22C3.1 21.93 2 23.85 2 26c0 2.15 1.1 4.07 2.8 5.3l6.7-5.05z"/>
//     <path fill="#EA4335" d="M24 46c6.38 0 11.7-2.1 15.6-5.7l-7.62-5.94c-2.1 1.45-4.8 2.33-7.98 2.33-6.54 0-12.1-4.4-14.1-10.3l-6.7 5.22C8.9 41.9 15.7 46 24 46z"/>
//   </svg>
// );

// Facebook logo (blue)
const FacebookLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="#1877F2"
  >
    <path d="M22.67 0H1.33C.6 0 0 .6 0 1.33v21.34C0 23.4.6 24 1.33 24h11.5v-9.3H9.69v-3.6h3.14v-2.67c0-3.1 1.9-4.8 4.67-4.8 1.33 0 2.47.1 2.8.15v3.25h-1.92c-1.5 0-1.8.72-1.8 1.77v2.25h3.6l-.47 3.6h-3.13V24h6.13c.73 0 1.33-.6 1.33-1.33V1.33C24 .6 23.4 0 22.67 0z"/>
  </svg>
);

// const FacebookLogo = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="currentColor"
//     aria-hidden="true"
//   >
//     <path d="M22.67 0H1.33C.6 0 0 .6 0 1.33v21.34C0 23.4.6 24 1.33 24h11.5v-9.3H9.69v-3.6h3.14v-2.67c0-3.1 1.9-4.8 4.67-4.8 1.33 0 2.47.1 2.8.15v3.25h-1.92c-1.5 0-1.8.72-1.8 1.77v2.25h3.6l-.47 3.6h-3.13V24h6.13c.73 0 1.33-.6 1.33-1.33V1.33C24 .6 23.4 0 22.67 0z"/>
//   </svg>
// );



function Checkout() {
  const [showBanner] = useState(true);

  return (
    <>
      {/* 🔵 NEW YEAR SALE BANNER */}
      {showBanner && (
        <div className="newyear-banner">
          <div className="banner-inner">
            <span>
              New Year Sale: <strong>Save 60%.</strong> Offer ends soon.
            </span>
            {/* <button
              className="banner-close"
              onClick={() => setShowBanner(false)}
            >
              ×
            </button> */}
          </div>
        </div>
      )}

      {/* 🔵 CHECKOUT PAGE */}
      <div className="checkout-container">
        <h1 className="checkout-title">Checkout</h1>

        <div className="checkout-grid">
          {/* LEFT SIDE */}
          <div className="account-section">
            <div className="step-header">
              <span className="step-number">1</span>
              <h2>Account</h2>
            </div>

            <h3>Sign in or Create account</h3>

            <input
              type="email"
              placeholder="Enter your email"
              className="email-input"
            />

            <button className="continue-btn">Continue</button>

             {/* OR Divider */}
            <div className="or-divider">
               <span>OR</span>
             </div>

            <div className="social-buttons">
              <button> Continue with Apple</button>
              <button>Continue with Google</button>
              <button> Continue with Facebook</button>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="summary-section">
            <h2>Annual Access</h2>
            <h3>$79.00 your first year</h3>

            <p>
              You will be automatically charged $79.00 for the first year.
              Subscription renews at $149/year thereafter.
            </p>

            <hr />

            <h4>What you get:</h4>
            <ul>
              <li>Unlimited access to RedboxGlobal.com</li>
              <li>Unlimited live radio & podcasts</li>
              <li>Exclusive video content</li>
              <li>Subscriber-only newsletters</li>
              <li>5 gift articles per month</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Checkout;
